class PrescriptionKeyController {

    /* @ngInject */
    constructor($scope, $log, $stateParams, $filter, $state, $interval, Users, Auth, ngDialog, toastr) {
      Object.assign(this, {
        $scope,
        $log,
        $stateParams,
        $filter,
        $state,
        $interval,
        Users,
        Auth,
        ngDialog,
        toastr,
      });

      this.rxKey = false;
      this.isDoctor = false;
      this.load();
      this.getKey();
    }

    getKey() {
      this.Users.getRxKeyPair()
      .then(() => {
        this.rxKey = true;
      })
      .catch((err) => {
        console.log(err);
      });
    }

    createKey() {
      this.Users.createRxKeyPair()
      .then(() => {
        this.toastr.success(`RX Key succesfully created`);
      })
      .catch((err) => {
        console.log(err);
        this.toastr.error(`Error creating RX Key`);
      });
    }

    load() {
      this.Users.getOne(this.Auth.profile.id)
      .then(({ data }) => {
        this.user = data;

        if (_.includes(this.user.roles, this.Users.ROLES.DOCTOR.NAME)) {
          this.isDoctor = true;
        }

        this.$log.debug('User: ', this.user);
      })
      .catch((err) => {
        console.log(err);
      });
    }
}

PrescriptionKeyController.$inject = ["$scope", "$log", "$stateParams", "$filter", "$state", "$interval", "Users", "Auth", "ngDialog", "toastr"];
angular.module('pims').controller('PrescriptionKeyController', PrescriptionKeyController);
